// @flow
import {connect} from 'react-redux';
import Sidebar from '../components/Sidebar';

import type {RootState} from '../../index';

export default connect(
  (state: RootState) => ({
    store: state.store.store,
    user: state.auth.user,
    resellerInformation: state.ui.resellerInformation,
    isFetchingResellerInformation: state.ui.isFetchingResellerInformation,
    storePreviousTier: state.store.storePreviousTier,
    storeTier: state.store.store?.storeTier,
  }),
  null
)(Sidebar);
